import { GameDetailsDTO } from '../interfaces/GameDetailsResponseDTO';
import { GameDetails, GameDetailsTeam, GameEvent, GameEventType } from '../interfaces/GameDetails';
import { parseGameEventTime, sortGameEvents } from 'modules/games/utils/games-utils';

function mapGameEvents(match: GameDetailsDTO): GameEvent[] {
  const teams = match.teamMatches.map((teamMatch) => teamMatch.team);
  const { matchEvents } = match;

  if (!matchEvents || !matchEvents.length || !matchEvents[0].period) {
    return [];
  }

  const events = matchEvents.map((matchEvent) => {
    const {
      minutes,
      extraMinutes,
    } = parseGameEventTime(matchEvent.second, matchEvent.period);

    const firstPlayerId = matchEvent.user.id;
    const secondaryPlayerId = matchEvent.secondaryUser?.id || 0;
    const team = teams.find((team) => team.members.some((member) => member.user.id === firstPlayerId));
    const { id: teamId } = team || {};
    const playerIds = secondaryPlayerId ? [firstPlayerId, secondaryPlayerId] : [firstPlayerId];

    if (!teamId) {
      const applicationTeam = teams.find((t) => {
        const app = t.championshipApplications.find((ca) => (
          ca.championship.id === match.championship.id
          && ca.user.id === firstPlayerId
        ));

        return !!app;
      });


      return {
        id: matchEvent.id,
        type: matchEvent.type,
        seconds: matchEvent.second,
        period: matchEvent.period,
        minutes,
        extraMinutes,
        teamId: applicationTeam ? applicationTeam.id : 0,
        playerIds,
        // playerIds: [teams[0].members[0].user.id],
      } as GameEvent;
    }

    const type = secondaryPlayerId && matchEvent.type === GameEventType.GOAL
      ? GameEventType.PASS_AND_GOAL
      : matchEvent.type as GameEventType;

    return {
      id: matchEvent.id,
      type,
      seconds: matchEvent.second,
      period: matchEvent.period,
      minutes,
      extraMinutes,
      teamId,
      playerIds,
    } as GameEvent;
  });

  return sortGameEvents(events);
}

export function mapGameDetails(match: GameDetailsDTO): GameDetails {
  const teams = match.teamMatches.map((teamMatch) => {
    const { team } = teamMatch;
    const currentApplications = team.championshipApplications.filter((item) => item.championship.id === match.championship.id);
    const allMembers: Record<number, { position: string, number: number; }> = team.members.reduce((result, member) => ({
      ...result,
      [member.user.id]: {
        position: member.position,
        number: member.number,
      }
    }), {});

    return {
      id: team.id,
      name: team.name,
      logo: team.emblem?.externalUrl,
      members: currentApplications.map((item) => ({
        id: item.user.id,
        firstName: item.user.name,
        lastName: item.user.surname,
        avatar: item.user.photo?.externalUrl || '',
        position: allMembers[item.user.id]?.position || 'defender',
        number: allMembers[item.user.id]?.number || 100,
      })),
    };
  }) as [GameDetailsTeam, GameDetailsTeam];

  const participants = (match.participants || []).reduce<number[]>((results, item) => {
    if (item.match.id === match.id && item.isInvolved) {
      return [
        ...results,
        item.user.id,
      ];
    }

    return results;
  }, []);

  console.log(match.participants, participants);

  return {
    id: match.id,
    sportType: match.sportType,
    date: new Date(match.date),
    championship: {
      id: match.championship.id,
      name: match.championship.name,
    },
    tournament: {
      id: match.tournament.id,
      name: match.tournament.name,
    },
    result: {
      firstTeamScore: match.teamMatches[0].score ?? 0,
      secondTeamScore: match.teamMatches[1].score ?? 0,
    },
    teams,
    events: mapGameEvents(match),
    round: match.round
      ? {
        id: match.round.id,
        name: match.round.name,
        stageId: match.round.stage.id,
      }
      : undefined,
    videoUrls: match.videos.map((video) => video.externalUrl),
    participants,
  };
}
